const initialState = {
  venueData: {},
};

const venues = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_VENUES':
      return { ...state, venueData: action.venueData };
    default:
      return state;
  }
};

export default venues;
